// Generated by scripts/generate-non-european-countries.mjs. Do not edit manually.
export const COUNTRIES = [
  { code: 'AF', currency: 'AFN', dial: '+93', name: 'Afghanistan' },
  { code: 'DZ', currency: 'DZD', dial: '+213', name: 'Algeria' },
  { code: 'AO', currency: 'AOA', dial: '+244', name: 'Angola' },
  { code: 'AG', currency: 'XCD', dial: '+1268', name: 'Antigua and Barbuda' },
  { code: 'AR', currency: 'ARS', dial: '+54', name: 'Argentina' },
  { code: 'AM', currency: 'AMD', dial: '+374', name: 'Armenia' },
  { code: 'AU', currency: 'AUD', dial: '+61', name: 'Australia' },
  { code: 'AZ', currency: 'AZN', dial: '+994', name: 'Azerbaijan' },
  { code: 'BS', currency: 'BSD', dial: '+1242', name: 'Bahamas' },
  { code: 'BH', currency: 'BHD', dial: '+973', name: 'Bahrain' },
  { code: 'BD', currency: 'BDT', dial: '+880', name: 'Bangladesh' },
  { code: 'BB', currency: 'BBD', dial: '+1246', name: 'Barbados' },
  { code: 'BZ', currency: 'BZD', dial: '+501', name: 'Belize' },
  { code: 'BJ', currency: 'XOF', dial: '+229', name: 'Benin' },
  { code: 'BT', currency: 'BTN', dial: '+975', name: 'Bhutan' },
  { code: 'BO', currency: 'BOB', dial: '+591', name: 'Bolivia' },
  { code: 'BW', currency: 'BWP', dial: '+267', name: 'Botswana' },
  { code: 'BR', currency: 'BRL', dial: '+55', name: 'Brazil' },
  { code: 'BN', currency: 'BND', dial: '+673', name: 'Brunei' },
  { code: 'BF', currency: 'XOF', dial: '+226', name: 'Burkina Faso' },
  { code: 'BI', currency: 'BIF', dial: '+257', name: 'Burundi' },
  { code: 'KH', currency: 'KHR', dial: '+855', name: 'Cambodia' },
  { code: 'CM', currency: 'XAF', dial: '+237', name: 'Cameroon' },
  { code: 'CA', currency: 'CAD', dial: '+1', name: 'Canada' },
  { code: 'CV', currency: 'CVE', dial: '+238', name: 'Cape Verde' },
  { code: 'CF', currency: 'XAF', dial: '+236', name: 'Central African Republic' },
  { code: 'TD', currency: 'XAF', dial: '+235', name: 'Chad' },
  { code: 'CL', currency: 'CLP', dial: '+56', name: 'Chile' },
  { code: 'CN', currency: 'CNY', dial: '+86', name: 'China' },
  { code: 'CO', currency: 'COP', dial: '+57', name: 'Colombia' },
  { code: 'KM', currency: 'KMF', dial: '+269', name: 'Comoros' },
  { code: 'CR', currency: 'CRC', dial: '+506', name: 'Costa Rica' },
  { code: 'CU', currency: 'CUP', dial: '+53', name: 'Cuba' },
  { code: 'DJ', currency: 'DJF', dial: '+253', name: 'Djibouti' },
  { code: 'DM', currency: 'XCD', dial: '+1767', name: 'Dominica' },
  { code: 'DO', currency: 'DOP', dial: '+1809', name: 'Dominican Republic' },
  { code: 'CD', currency: 'CDF', dial: '+243', name: 'DR Congo' },
  { code: 'EC', currency: 'USD', dial: '+593', name: 'Ecuador' },
  { code: 'EG', currency: 'EGP', dial: '+20', name: 'Egypt' },
  { code: 'SV', currency: 'USD', dial: '+503', name: 'El Salvador' },
  { code: 'GQ', currency: 'XAF', dial: '+240', name: 'Equatorial Guinea' },
  { code: 'ER', currency: 'ERN', dial: '+291', name: 'Eritrea' },
  { code: 'SZ', currency: 'SZL', dial: '+268', name: 'Eswatini' },
  { code: 'ET', currency: 'ETB', dial: '+251', name: 'Ethiopia' },
  { code: 'FJ', currency: 'FJD', dial: '+679', name: 'Fiji' },
  { code: 'GA', currency: 'XAF', dial: '+241', name: 'Gabon' },
  { code: 'GM', currency: 'GMD', dial: '+220', name: 'Gambia' },
  { code: 'GE', currency: 'GEL', dial: '+995', name: 'Georgia' },
  { code: 'GH', currency: 'GHS', dial: '+233', name: 'Ghana' },
  { code: 'GD', currency: 'XCD', dial: '+1473', name: 'Grenada' },
  { code: 'GT', currency: 'GTQ', dial: '+502', name: 'Guatemala' },
  { code: 'GN', currency: 'GNF', dial: '+224', name: 'Guinea' },
  { code: 'GY', currency: 'GYD', dial: '+592', name: 'Guyana' },
  { code: 'HT', currency: 'HTG', dial: '+509', name: 'Haiti' },
  { code: 'HN', currency: 'HNL', dial: '+504', name: 'Honduras' },
  { code: 'IN', currency: 'INR', dial: '+91', name: 'India' },
  { code: 'ID', currency: 'IDR', dial: '+62', name: 'Indonesia' },
  { code: 'IR', currency: 'IRR', dial: '+98', name: 'Iran' },
  { code: 'IQ', currency: 'IQD', dial: '+964', name: 'Iraq' },
  { code: 'IL', currency: 'ILS', dial: '+972', name: 'Israel' },
  { code: 'CI', currency: 'XOF', dial: '+225', name: 'Ivory Coast' },
  { code: 'JM', currency: 'JMD', dial: '+1876', name: 'Jamaica' },
  { code: 'JP', currency: 'JPY', dial: '+81', name: 'Japan' },
  { code: 'JO', currency: 'JOD', dial: '+962', name: 'Jordan' },
  { code: 'KZ', currency: 'KZT', dial: '+7', name: 'Kazakhstan' },
  { code: 'KE', currency: 'KES', dial: '+254', name: 'Kenya' },
  { code: 'KI', currency: 'AUD', dial: '+686', name: 'Kiribati' },
  { code: 'KW', currency: 'KWD', dial: '+965', name: 'Kuwait' },
  { code: 'KG', currency: 'KGS', dial: '+996', name: 'Kyrgyzstan' },
  { code: 'LA', currency: 'LAK', dial: '+856', name: 'Laos' },
  { code: 'LB', currency: 'LBP', dial: '+961', name: 'Lebanon' },
  { code: 'LS', currency: 'LSL', dial: '+266', name: 'Lesotho' },
  { code: 'LR', currency: 'LRD', dial: '+231', name: 'Liberia' },
  { code: 'LY', currency: 'LYD', dial: '+218', name: 'Libya' },
  { code: 'MG', currency: 'MGA', dial: '+261', name: 'Madagascar' },
  { code: 'MW', currency: 'MWK', dial: '+265', name: 'Malawi' },
  { code: 'MY', currency: 'MYR', dial: '+60', name: 'Malaysia' },
  { code: 'MV', currency: 'MVR', dial: '+960', name: 'Maldives' },
  { code: 'ML', currency: 'XOF', dial: '+223', name: 'Mali' },
  { code: 'MH', currency: 'USD', dial: '+692', name: 'Marshall Islands' },
  { code: 'MR', currency: 'MRU', dial: '+222', name: 'Mauritania' },
  { code: 'MU', currency: 'MUR', dial: '+230', name: 'Mauritius' },
  { code: 'MX', currency: 'MXN', dial: '+52', name: 'Mexico' },
  { code: 'FM', currency: 'USD', dial: '+691', name: 'Micronesia' },
  { code: 'MN', currency: 'MNT', dial: '+976', name: 'Mongolia' },
  { code: 'MA', currency: 'MAD', dial: '+212', name: 'Morocco' },
  { code: 'MZ', currency: 'MZN', dial: '+258', name: 'Mozambique' },
  { code: 'MM', currency: 'MMK', dial: '+95', name: 'Myanmar' },
  { code: 'NA', currency: 'NAD', dial: '+264', name: 'Namibia' },
  { code: 'NR', currency: 'AUD', dial: '+674', name: 'Nauru' },
  { code: 'NP', currency: 'NPR', dial: '+977', name: 'Nepal' },
  { code: 'NZ', currency: 'NZD', dial: '+64', name: 'New Zealand' },
  { code: 'NI', currency: 'NIO', dial: '+505', name: 'Nicaragua' },
  { code: 'NE', currency: 'XOF', dial: '+227', name: 'Niger' },
  { code: 'NG', currency: 'NGN', dial: '+234', name: 'Nigeria' },
  { code: 'KP', currency: 'KPW', dial: '+850', name: 'North Korea' },
  { code: 'OM', currency: 'OMR', dial: '+968', name: 'Oman' },
  { code: 'PK', currency: 'PKR', dial: '+92', name: 'Pakistan' },
  { code: 'PW', currency: 'USD', dial: '+680', name: 'Palau' },
  { code: 'PS', currency: 'ILS', dial: '+970', name: 'Palestine' },
  { code: 'PA', currency: 'PAB', dial: '+507', name: 'Panama' },
  { code: 'PG', currency: 'PGK', dial: '+675', name: 'Papua New Guinea' },
  { code: 'PY', currency: 'PYG', dial: '+595', name: 'Paraguay' },
  { code: 'PE', currency: 'PEN', dial: '+51', name: 'Peru' },
  { code: 'PH', currency: 'PHP', dial: '+63', name: 'Philippines' },
  { code: 'QA', currency: 'QAR', dial: '+974', name: 'Qatar' },
  { code: 'CG', currency: 'XAF', dial: '+242', name: 'Republic of the Congo' },
  { code: 'RW', currency: 'RWF', dial: '+250', name: 'Rwanda' },
  { code: 'KN', currency: 'XCD', dial: '+1869', name: 'Saint Kitts and Nevis' },
  { code: 'LC', currency: 'XCD', dial: '+1758', name: 'Saint Lucia' },
  { code: 'VC', currency: 'XCD', dial: '+1784', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', currency: 'WST', dial: '+685', name: 'Samoa' },
  { code: 'ST', currency: 'STN', dial: '+239', name: 'São Tomé and Príncipe' },
  { code: 'SA', currency: 'SAR', dial: '+966', name: 'Saudi Arabia' },
  { code: 'SN', currency: 'XOF', dial: '+221', name: 'Senegal' },
  { code: 'SC', currency: 'SCR', dial: '+248', name: 'Seychelles' },
  { code: 'SL', currency: 'SLE', dial: '+232', name: 'Sierra Leone' },
  { code: 'SG', currency: 'SGD', dial: '+65', name: 'Singapore' },
  { code: 'SB', currency: 'SBD', dial: '+677', name: 'Solomon Islands' },
  { code: 'SO', currency: 'SOS', dial: '+252', name: 'Somalia' },
  { code: 'ZA', currency: 'ZAR', dial: '+27', name: 'South Africa' },
  { code: 'KR', currency: 'KRW', dial: '+82', name: 'South Korea' },
  { code: 'SS', currency: 'SSP', dial: '+211', name: 'South Sudan' },
  { code: 'LK', currency: 'LKR', dial: '+94', name: 'Sri Lanka' },
  { code: 'SD', currency: 'SDG', dial: '+249', name: 'Sudan' },
  { code: 'SR', currency: 'SRD', dial: '+597', name: 'Suriname' },
  { code: 'SY', currency: 'SYP', dial: '+963', name: 'Syria' },
  { code: 'TW', currency: 'TWD', dial: '+886', name: 'Taiwan' },
  { code: 'TJ', currency: 'TJS', dial: '+992', name: 'Tajikistan' },
  { code: 'TZ', currency: 'TZS', dial: '+255', name: 'Tanzania' },
  { code: 'TH', currency: 'THB', dial: '+66', name: 'Thailand' },
  { code: 'TL', currency: 'USD', dial: '+670', name: 'Timor-Leste' },
  { code: 'TG', currency: 'XOF', dial: '+228', name: 'Togo' },
  { code: 'TO', currency: 'TOP', dial: '+676', name: 'Tonga' },
  { code: 'TT', currency: 'TTD', dial: '+1868', name: 'Trinidad and Tobago' },
  { code: 'TN', currency: 'TND', dial: '+216', name: 'Tunisia' },
  { code: 'TR', currency: 'TRY', dial: '+90', name: 'Turkey' },
  { code: 'TM', currency: 'TMT', dial: '+993', name: 'Turkmenistan' },
  { code: 'TV', currency: 'AUD', dial: '+688', name: 'Tuvalu' },
  { code: 'UG', currency: 'UGX', dial: '+256', name: 'Uganda' },
  { code: 'AE', currency: 'AED', dial: '+971', name: 'United Arab Emirates' },
  { code: 'US', currency: 'USD', dial: '+1', name: 'United States' },
  { code: 'UY', currency: 'UYU', dial: '+598', name: 'Uruguay' },
  { code: 'UZ', currency: 'UZS', dial: '+998', name: 'Uzbekistan' },
  { code: 'VU', currency: 'VUV', dial: '+678', name: 'Vanuatu' },
  { code: 'VE', currency: 'VES', dial: '+58', name: 'Venezuela' },
  { code: 'VN', currency: 'VND', dial: '+84', name: 'Vietnam' },
  { code: 'EH', currency: 'MAD', dial: '+212', name: 'Western Sahara' },
  { code: 'YE', currency: 'YER', dial: '+967', name: 'Yemen' },
  { code: 'ZM', currency: 'ZMW', dial: '+260', name: 'Zambia' },
  { code: 'ZW', currency: 'ZWG', dial: '+263', name: 'Zimbabwe' },
];
